import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareFromSquare } from '@fortawesome/free-solid-svg-icons'

import { DocumentsTabDisplay } from '@/components/features/Document/components'
import { OutputLocationType } from '@/components/features/ItemOutputLocation/types'

import { AskCustomerToAnswerModal } from '../AskCustomerToAnswerModal'
import { EmailPreviewModal } from '../EmailPreviewModal'
import { ConfirmationPropsType } from '../../types'
import { convertInputTypeToAnswerType } from '../../hooks/useCustomerContractForm'

export const Confirmation: React.FC<ConfirmationPropsType> = (props) => {
  const [showAskCustomerToAnswerModal, setShowAskCustomerToAnswerModal] = useState(false)
  const [showEmailPreviewModal, setShowEmailPreviewModal] = useState(false)

  let existAnswerByCustomer = false
  const answerOutputLocations: OutputLocationType[] = []
  Object.keys(props.customerContract?.answerItems).forEach((questionItemId) => {
    const questionItem = props.contractSetting?.questionItems.find((question) => question.id === questionItemId)
    if (!questionItem) return

    const answerItem = props.customerContract?.answerItems[questionItemId]
    existAnswerByCustomer = existAnswerByCustomer || !!answerItem.byCustomer
    if (!answerItem.value) return

    const itemLocations: OutputLocationType[] =
      questionItem.outputLocations?.map((loc) => {
        const originalDocument = props.contractSetting?.draftDocuments.find((doc) => doc.id === loc.documentId)
        const document = props.customerContract.documents.find((doc) => doc.blobId === originalDocument?.blobId)
        return {
          ...loc,
          label: questionItem.label,
          documentId: document?.id || loc.documentId,
          sublabel: questionItem.sublabel,
          value: answerItem.value,
          subvalue: answerItem.subvalue,
          unit: questionItem.unit,
          answerType: questionItem.answerType,
          itemKey: questionItem.id,
          width: questionItem?.width,
          height: questionItem?.height,
        }
      }) || []
    answerOutputLocations.push(...itemLocations)
  })
  const fieldOutputLocations: OutputLocationType[] =
    props.customerContract?.contractInvitees?.flatMap((invitee) => {
      const inviteeFields = invitee.documentFields.flatMap((field) => {
        const fieldLocations = field.fieldLocations.map((loc) => ({
          ...loc,
          itemKey: field.id,
          label: `${invitee.inviteeLastName}${invitee.inviteeFirstName}`,
          documentId: field.documentId,
          answerType: convertInputTypeToAnswerType(field.inputType),
        }))
        return fieldLocations
      })
      return inviteeFields
    }) || []
  const fixedOutputLocations = [...answerOutputLocations, ...fieldOutputLocations]

  return (
    <>
      <AskCustomerToAnswerModal
        show={showAskCustomerToAnswerModal}
        setShow={setShowAskCustomerToAnswerModal}
        customerContract={props.customerContract}
        refreshCustomerContract={props.refreshCustomerContract}
        customerAnswerPageUrl={props.customerAnswerPageUrl}
        customerAnswerPageImageSrc={props.customerAnswerPageImageSrc}
      />
      <EmailPreviewModal
        show={showEmailPreviewModal}
        setShow={setShowEmailPreviewModal}
        customerContract={props.customerContract}
        refreshCustomerContract={props.refreshCustomerContract}
      />
      <header className="row align-items-center justify-content-end sticky-top bg-white z-1500">
        <Col className="h4 mb-0 text-truncate">{props.customerContract?.name}</Col>
        <Col className="text-end text-nowrap">
          {existAnswerByCustomer && props.customerContract?.status === 'draft' && (
            <Button variant="outline-primary" onClick={() => setShowAskCustomerToAnswerModal(true)}>
              <FontAwesomeIcon icon={faShareFromSquare} /> <span>書面入力用 QR・URLの発行</span>
            </Button>
          )}
          <Button
            variant="success"
            className="ms-3"
            onClick={() => setShowEmailPreviewModal(true)}
            disabled={props.customerContract?.status !== 'draft'}
          >
            {props.customerContract?.status === 'draft' ? '電子署名依頼メール送信' : '送信済み'}
          </Button>
        </Col>
      </header>
      <Row>
        <Col className="">
          <Row className="gy-2 mt-3 mx-0 border-bottom">
            <Col lg={2} md={3}>
              承認ユーザー
            </Col>
            <Col lg={10} md={9}>
              {props.customerContract?.contractInvitees
                ?.filter((invitee) => invitee.inviteeType === 'User')
                .map((approver) => (
                  <span key={approver.inviteeId} className="me-3">
                    {approver.inviteeLastName}
                    {approver.inviteeFirstName}
                  </span>
                )) || null}
            </Col>
          </Row>
          <DocumentsTabDisplay
            documents={props.customerContract?.documents || []}
            fixedOutputLocations={fixedOutputLocations}
            tabsClassName="pt-5"
          />
          {(props.customerContract?.attachmentDocuments?.length ?? 0) > 0 && (
            <div className="mt-4">
              <h6 className="text-muted">添付書類&#x3000;※電子署名されません。</h6>
              <DocumentsTabDisplay
                documents={props.customerContract.attachmentDocuments || []}
                outputLocations={[]}
                tabsClassName="pt-3"
              />
            </div>
          )}
        </Col>
      </Row>
    </>
  )
}
